import { GridApi } from 'ag-grid-community';
import { useCallback } from 'react';
import { useInterval } from 'usehooks-ts';

const isPageVisible = () => {
  const document = window.document;
  return document.visibilityState === 'visible';
};

export function useGridAutoRefresh(api: GridApi | undefined | null) {
  const handlePolling = useCallback(() => {
    if (api !== null && api !== undefined && isPageVisible()) {
      api.refreshServerSide({ purge: false });
    }
  }, [api]);
  useInterval(handlePolling, window.sgmeConfiguration.blotterPollingIntervalMs ?? 10_000);
}
